module.exports = __webpack_public_path__ + "img/Sutter_health_logo.097afe15.png";